export default {
    clientID: 'b763a131-530e-405d-a6fd-bffaf31f3b1a',
    authority: 'https://login.microsoftonline.com/9b50c80f-103b-4433-a91c-b4b06c507387/',
    tenantID: '9b50c80f-103b-4433-a91c-b4b06c507387',
    resourceScopes:['api_access'],
    scopes:['User.Read'],
    cacheLocation:'localStorage',
    storeAuthStateInCookie: false
    //Instance: 'https://login.microsoftonline.com/9b50c80f-103b-4433-a91c-b4b06c507387/oauth2/v2.0/token'
                
}


/*export default 
{
    clientID: 'aa2e647e-4aaa-42d7-bf17-3ad832cb87a8',
    tenantID: '9b50c80f-103b-4433-a91c-b4b06c507387',
    authority: 'https://login.microsoftonline.com/9b50c80f-103b-4433-a91c-b4b06c507387/',                
    redirectUri:'http://localhost:8080'
}*/